import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const SendIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M22.7 1.3a1 1 0 0 1 .2 1l-7 20a1 1 0 0 1-1.8.1l-3.9-8.6-8.6-3.9a1 1 0 0 1 0-1.8l20-7a1 1 0 0 1 1.1.2Zm-4.5 3L4.7 9.2l6 2.7 7.5-7.4Zm-6 9 7.4-7.5L15 19.3l-2.7-6Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default SendIcon;
